import React, { ReactElement } from 'react';
import Badge from 'components/Badge/Badge';
import { LinkCell, UserNameCell } from 'components/Cells/Cells';
import styles from 'assets/jss/material-dashboard-pro-react/views/accounts/contactRowStyle';
import { makeStyles } from '@material-ui/core';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IContactRowProps {
	icon?: ReactElement;
	name: string;
	department?: string;
	color?: 'primary' | 'warning' | 'danger' | 'success' | 'info' | 'rose' | 'gray';
	hexColor?: string;
	path: string;
	accessible?: boolean;
	type: 'ADMIN' | 'MANAGER' | 'ENDUSER';
}

const ContactRow = ({ icon, name, department, color, hexColor, path, accessible, type }: IContactRowProps) => {
	const classes = useStyles();

	return (
		<div className={classes.row}>
			<ConditionalRender
				show={!!accessible}
				onTrue={() => <LinkCell path={path} text={name} icon={icon} />}
				onFalse={() => <UserNameCell text={name} type={type} />}
			/>
			<Badge filled color={color} hexColor={hexColor}>
				{department}
			</Badge>
		</div>
	);
};

export default ContactRow;
